import { Spinner, SpinnerFallback } from 'components/Loaders/Spinner';
import {
  LoaderContainer,
  LoaderContainerFallback,
} from 'components/Loaders/useAnimationLoader';

export const DefaultLoader = () => (
  <>
    <LoaderContainerFallback>
      <SpinnerFallback />
    </LoaderContainerFallback>
    <LoaderContainer data-testid="loader-container">
      <Spinner />
    </LoaderContainer>
  </>
);
